import { Component, Input } from '@angular/core';


@Component({
  selector: 'igo-spinner',
  template: require('./spinner.component.html'),
  styles: [require('./spinner.component.styl')],
})
export class SpinnerComponent {

  @Input()
  get shown() { return this._shown; }
  set shown(value: boolean) {
    this._shown = value;
  }
  private _shown: boolean = false;

  constructor() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/shared/spinner/spinner.component.ts